import { render } from "./chartD.vue?vue&type=template&id=3f3f53c0"
import script from "./chartD.vue?vue&type=script&lang=ts"
export * from "./chartD.vue?vue&type=script&lang=ts"
script.render = render

export default script